import Earning from "../../api/earning/Earning";
import React from "react";
import {Link} from "react-router-dom";
import {getEditRoute} from "../../../../common/Routing";
import {ROUTES} from "../../../../AppRouter";
import {RowComponentProps} from "../../../../components/widgets/table/RowComponentProps";
import TableDeleteButton from "../../../../components/widgets/table/TableDeleteButton";

const EarningRow: React.FC<RowComponentProps<Earning>> = ({
  item,
  onDeleteClick,
  entityName
}) => (
  <tr>
    <td>
      <Link
        to={getEditRoute(ROUTES.EARNING_EDIT, item.id)}
        className="nav-link"
      >
        {item.name}
      </Link>
    </td>
    <td>{item.type}</td>
    <td>{item.stpType}</td>
    <td>
      <TableDeleteButton
        entityName={entityName}
        onDeleteClick={() => {
          onDeleteClick(item.id);
        }}
      />
    </td>
  </tr>
);

export { EarningRow };
